import type { ResponseBody } from "@src/packages/openapi/helpers";
import type { paths } from "@src/packages/openapi/schema";

export type MedicationCatalogItem = ResponseBody<
  paths["/medication-catalog"]["get"]
>["data"]["items"][number];

export function findMedicationByName(
  medications: MedicationCatalogItem[],
  name: string,
) {
  const normalized = name.trim().toLowerCase();
  return (
    medications.find(
      (medication) => medication.productName.toLowerCase() === normalized,
    ) ?? null
  );
}

/** Keep an explicit pack/search identity; otherwise link a loaded exact match. */
export function resolveMedicationCatalogId(
  selectedId: string | null,
  medications: MedicationCatalogItem[],
  name: string,
) {
  return (
    selectedId ?? findMedicationByName(medications, name)?.medicationId ?? null
  );
}
